import type { FaireProductEntity } from "../../entity_types/product";

export const p_ad85islrx1: FaireProductEntity = {
  token: "p_ad85islrx1",
  type: "product",
  name: "Lavender and Indigo Pillow 2 sizes",
  brandToken: "b_b067eaumjh",
  brandName: "Happy French Gang",
  imageUrl:
    "https://cdn.faire.com/fastly/b4c2068d1310c8dd85456de2927a8afb81eeef4f274022fb28bd66254c56603b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/392965f3ed5337632f69e2c9e5f35e2562e2b07774161ad9023c913569694aa6.jpeg",
    "https://cdn.faire.com/fastly/5b2e24eaa400be91601580321149ae86aaa1974331cff53b901f6819aa5871ca.png",
    "https://cdn.faire.com/fastly/2602883f96350b42daed420ee9eba1d26fba0ede38b805aaa794dd59906ea628.png",
  ],
  priceDollars: 70,
  description:
    'Color: lavender/indigo.\nSize: 28” x 28” or 18x18"\nFilled with feather & down.\nNatural dyes.\n100% organic cotton, hand-spun and handwoven.',
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:00.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
